// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'calFont', 'calFont Fallback'","fontWeight":600},"className":"__className_a90182","variable":"__variable_a90182"};